import type { CommerceFeature, CommerceFeatureSet } from "@teqtank/commerce-contracts";

const SUPPORTED_COMMERCE_FEATURES = new Set<CommerceFeature>([
    "partner-storefront",
    "coupons",
    "customer-create",
    "guest-checkout",
    "email-verification-code",
    "email-verification-code-preview",
    "inventory-visibility",
    "order-submit",
    "quick-buy",
    "rewards",
    "recurring",
]);

export function createCommerceFeatureSet(features: readonly CommerceFeature[]): CommerceFeatureSet {
    const enabled = [...new Set(features)].sort() as CommerceFeature[];

    for (const feature of enabled) {
        if (!SUPPORTED_COMMERCE_FEATURES.has(feature)) {
            throw new TypeError(`Unsupported Commerce feature '${String(feature)}'.`);
        }
    }

    const enabledFeatures = new Set(enabled);

    return Object.freeze({
        enabled: Object.freeze(enabled),

        has(feature: CommerceFeature): boolean {
            return enabledFeatures.has(feature);
        },
    });
}
